<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">

        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="mt-10">
            <p>Die Engelstrompete wurde zur Luminale 2012 im Frankfurter Palmengarten realisiert.</p>
            <br>
            <p class="font-semibold">Konzept. Nachwachsende Rohstoffe</p>
            <p>Der Entwurf basiert auf der Idee, einen nachwachsenden regionalen Rohstoff auf innovative Art und Weise zu verarbeiten und in Verbindung mit einem modernen Material einen vollkommen neuen Raumcharakter entstehen zu lassen. Der Pavillon - ein leichtes Flächentragwerk - besteht aus einer filigranen Tragstruktur aus regionalen Hölzern und einer trans-luzenten Membran. Beide Materialien verbinden sich zu einem harmonischen Ganzen, das die Idee von Nachhaltigkeit auf zukunftsweisende Weise interpretiert und dem Technischen einen poetischen Ausdruck verleiht.</p>
            <p class="font-semibold">Temporär, mobil und nachhaltig.</p>
            <p>Eine modulare Bauweise ermöglicht den schnellen Auf-/Abbau und Transport. Die spezielle Bauweise macht den Pavillon zu einem vollkommen recyclingfähigen Bau: Alle verarbeiteten Materialien können problemlos getrennt werden, es werden keine umwelt-belastenden Compounds genutzt oder hergestellt.
            </p>
            <p class="font-semibold">Inspiration</p>
            <p>Die Blüte der Engelstrompete ist das Vorbild für die Konstruktion des Pavillons. In abstrahierter Form „entfaltet“ sie eine große Bandbreite an gestalterischen Möglichkeiten. Durch die Anordnung im Raum entstehen interessante Überlagerungen und Zwischenräume, der Unterschied zwischen Innen und Außen verwischt.
            </p>
            <p class="font-semibold">Projektion und Sound</p>
            <p>Der Pavillon ist als Analogie zu einem lebenden Organismus gedacht, der auf seine Umwelt reagiert und mit ihr kommuniziert, visuell und akustisch. Die transluzente Membran bildet die Haut zwischen den hölzernen Blattrippen und dient gleichzeitig als Reflexionsfläche bzw. Raum für Videoprojektionen. Bewegte Formen und wechselnde Farben unterstreichen die Analogie zum lebenden Organismus.
                Begleitet wird die visuelle Ebene von einem Klangraum, der von Dominik Eulberg konzipiert und realisiert wurde. Naturgeräusche und Geräusche aus der Stadtumgebung wurden als Rohstoff für den elektronischen Klangraum verwendet. </p>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="mt-5">
            <span class="font-semibold">Entwurf und Realisierung</span><br />
            <p class="leading-tight">
                Prof. Dr. Markus Holzbach sowie Aldo Freund, Philip Kliem, Barbara Wildung, Benjamin Würkner, Nikita Bagdulin, Patrick König, Sarah Lilienthal, Martin Pohlmann, Nico Reinhardt<br />
                <br />
                <span class="font-semibold">Sound</span><br />
                Dominik Eulberg<br />
                <br />
                <span class="font-semibold">Projektionen</span><br />
                Paul Simon Heyduck, Raoul Wilken<br />
                <br />
                <span class="font-semibold">Sponsoren</span><br />
                Palmengarten Frankfurt, Dominik Eulberg, Sonosfera, satis&fy, Gründach e.k., Bagger Born GmbH, Gazeshop.de<br />
                <br />
                <span class="font-semibold">Dokumentation</span><br />
                Emily Wabitsch
                <br>
                Rudi Weißbeck
                <br />
                <br>
                Projekt an der Kunsthochschule HfG Offenbach
            </p>
        </div>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/DSC_4361.jpg' ),
                require( '@/assets/img/pc/DSC_4362.jpg' ),
                require( '@/assets/img/pc/DSC_4442.jpg' ),
                require( '@/assets/img/pc/DSC_4492.jpg' ),
                require( '@/assets/img/pc/DSC_4536.jpg' ),
                require( '@/assets/img/pc/engelstrompete_1.jpg' ),
                require( '@/assets/img/pc/engelstrompete_2.jpg' ),
                require( '@/assets/img/pc/engelstrompete_5.jpg' ),
                require( '@/assets/img/pc/engelstrompete_4.jpg' ),
                require( '@/assets/img/pc/engelstrompete_3.jpg' ),
                require( '@/assets/img/pc/engelstrompete_6.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>